import React, { Component } from 'react';
import { EUIComboBox } from '../EUI/EUIComboBox';

export class ComboBoxStatutEventHub extends Component {

    static defaultProps = {
        label: "Statut",
        placeholder: "Statut",
    };

    render = () => {

        const fetchMethod = () => new Promise((resolve, reject) => {
            const options = [
                { key: 1, text: "A faire" },
                { key: 2, text: "En cours" },
                { key: 3, text: "Terminé" },
                { key: 4, text: "Annulé" },
                { key: 9, text: "A confirmer" },
                { key: 10, text: "Confirmé" },
                { key: 11, text: "Attente retour client" },
            ];
            resolve({ codeRetour: 0, reponseAPIobjet: options });
        });

        return <EUIComboBox
            {...this.props}
            fetchMethod={fetchMethod}
        />;

    };

};